import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">
              读者热评
            </h2>
            <p className="text-sm text-foreground-500">来自漫画爱好者的真实阅读感受</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {commentItems.map((comment) => (
              <div
                key={comment.id}
                className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70"
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                      <span className="text-xs text-foreground-500">{comment.time}</span>
                    </div>
                    <span className="inline-block text-xs text-primary-600 mt-0.5">
                      评 {comment.comic}
                    </span>
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  {comment.content}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                    <i className="ri-heart-line"></i>
                    {comment.likes.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                    <i className="ri-chat-1-line"></i>
                    回复
                  </span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                    <i className="ri-share-forward-line"></i>
                    分享
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}